import dragula from "dragula"

export default function dragOrgOwners() {
  $(".organizations ul.owner li .edit").on("click", () => {
    $(".organizations ul.owner li:not(.instructions)").remove()
    $(".organizations ul.owner li.instructions").show()

    $(".organizations .drag-options").show()

    const isInstructions = el => {
      return el.className.indexOf("instructions") != -1
    }

    const isOwnerField = el => {
      return el.className.indexOf("owner") != -1
    }

    let dragging = dragula(
      [$(".organizations ul.owner")[0], $(".organizations ul.admins")[0]],
      {
        copy: (el, source) => {
          return !isOwnerField(el)
        },
        moves: (el, source, handle, sibling) => {
          return !isInstructions(el) && !isOwnerField(source)
        },
      }
    )

    dragging.on("drop", (el, target, source, sibling) => {
      if (!target) {
        return
      }
      let $target = $(target)
      let $el = $(el)
      if (isOwnerField(target)) {
        $target.find("li").not(el).not(".gu-mirror").remove()
        if ($target.find(".draggable-user").not(".gu-mirror").length > 0) {
          $target.find(".instructions").hide()
          $el.find(".links").hide()
        } else {
          $target.find(".instructions").show()
          $el.find(".links").show()
        }
        // Update hidden owner_id form field
        $("#owner_id").val($el.attr("data-user-id"))
      } else {
        $el.find(".links").show()
      }
      $target.find("[data-user-id]").each(item => {
        $target
          .find(`[data-user-id=${$(item).attr("data-user-id")}]`)
          .not(item)
          .not(el)
          .not(".gu-mirror")
          .remove()
      })
    })

    dragging.on("over", (el, container, source) => {
      if (isOwnerField(container)) {
        $(container).find("li").not(el).not(".gu-mirror").hide()
      }
    })

    dragging.on("out", (el, container, source) => {
      if (isOwnerField(container)) {
        $(container).find("li").not(el).not(".gu-mirror").show()
      }
    })
  })
}
